import { DynamoImageLink } from './dynamo-image-link.blok';

export type {
  DynamoImageLinkProps,
  DynamoImageLinkBlok,
} from './dynamo-image-link.blok';

export default DynamoImageLink;
